// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"b4811460","126":"a2f2ca8d","306":"2450ec62","599":"5dda5d51","617":"aa9586b4","638":"9aca155e","722":"64ba3b04","969":"587ee340"}[chunkId] + ".chunk.css";
};